import React, { useRef } from 'react';
import AccordionContentRenderer from './AccordionContentRenderer';
import ServiceIcon from './ServiceIcon';
import './ServiceNestedAccordionItem.css';

const ServiceNestedAccordionItem = ({ item, isOpen, onToggle, itemRef }) => {
  const internalRef = useRef(null);
  const ref = itemRef || internalRef;

  return (
    <div ref={ref} className={`service-accordion-item ${isOpen ? 'open' : ''}`}>
      <div 
        className="service-accordion-header"
        onClick={onToggle}
      >
        <div className="service-accordion-header-content">
          <div className="service-accordion-icon-wrapper">
            <ServiceIcon name={item.icon} className="service-accordion-icon" />
          </div>
          <h4 className="service-accordion-title">{item.title}</h4>
        </div>
        <div className={`service-accordion-arrow ${isOpen ? 'open' : ''}`}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="service-accordion-content">
          <div className="service-accordion-content-inner">
            <AccordionContentRenderer content={item.content} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceNestedAccordionItem;

